import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import { Edit } from "react-feather";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Media,
  Table,
} from "reactstrap";
import { getBlockDetails } from "../../../../api";
import Chart from "react-apexcharts";
import { secondary } from "../string/StringChartData";

import dummyBlockPerfomance from "../../../../api/mock-data/block-data.json";

const BlockDetails = () => {
  const { id } = useParams();
  const [blockDetails, setBlockDetails] = useState([]);
  const [inverterList, setInverterList] = useState([]);
  const [blockPerformanceData, setBlockPerformanceData] = useState([]);

  const loadBlockPerformanceData = async (blockId) => {
    console.log(blockId);
    let data = dummyBlockPerfomance?.filter(
      (blockData) => blockData.block_id === blockId
    );
    setBlockPerformanceData(data);
  };

  const getData = async () => {
    const { data } = await getBlockDetails(id);
    setBlockDetails(data.data);
    setInverterList(data.data.inverters);
    loadBlockPerformanceData(id);
  };

  useEffect(() => {
    try {
      getData();
    } catch (error) {
      window.alert(error.message);
    }
  }, []);
  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col sm="12" xl="12">
            <Card>
              <CardHeader>
                <h5>{"Block Performance"} </h5>
              </CardHeader>
              <CardBody>
                <div id="basic-apex">
                  <Chart
                    options={{
                      colors: [secondary],
                      fill: {
                        type: "gradient",
                        gradient: {
                          shadeIntensity: 1,
                          opacityFrom: 0.7,
                          opacityTo: 0.5,
                          stops: [0, 80, 100],
                        },
                      },
                      dataLabels: {
                        enabled: false,
                      },
                      grid: {
                        show: false,
                      },
                      yaxis: {
                        title: {
                          text: "Specific Yield (KWh)",
                        },
                        decimalsInFloat: 3,
                      },
                      xaxis: {
                        title: {
                          text: "Time",
                        },
                        type: "datetime",
                        tickAmount: 1,
                        min: new Date(
                          blockPerformanceData?.[0]?.date
                        ).getTime(),
                      },
                    }}
                    series={[
                      {
                        name: "Plant Performance",
                        data: blockPerformanceData.map((item) => ({
                          y: item?.converted_power,
                          x: new Date(item?.date).getTime(), //moment(item?.timestamp).format('MMM/YY'),
                        })),
                      },
                    ]}
                    type="area"
                    height={350}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <div className="user-profile">
          <Row>
            <Col sm="12">
              <Card>
                <div className="profile-img-style">
                  <Row>
                    <Col sm="8">
                      <div className="media-body align-self-center">
                        <h1 className="mt-0 user-name">{"Block Details"}</h1>
                      </div>
                    </Col>
                  </Row>

                  <hr />

                  <Row>
                    <Col md="6">
                      <div className="ttl-info text-start">
                        <h6>Block ID</h6>
                        <span>{blockDetails?._id}</span>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="ttl-info text-start ttl-sm-mb-0">
                        <h6>Block Name</h6>
                        <span>{blockDetails?.name}</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <div className="ttl-info text-start ttl-sm-mb-0">
                        <h6>Raw Address</h6>
                        <span>{blockDetails?.address?.raw_address}</span>
                      </div>
                    </Col>
                  </Row>

                  {/* <div className="like-comment mt-4">
                      <ul className="list-inline">
                        <li className="list-inline-item border-end pe-3">
                          <label className="m-0">
                            <a href="#javascript">
                              <i className="fa fa-heart"></i>
                            </a>
                              {Like}
                          </label>
                          <span className="ms-2 counter">{"2659"}</span>
                        </li>
                        <li className="list-inline-item ms-2">
                          <label className="m-0">
                            <a href="#javascript">
                              <i className="fa fa-comment"></i>
                            </a>
                              {Comment}
                          </label>
                          <span className="ms-2 counter">{"569"}</span>
                        </li>
                      </ul>
                    </div> */}
                </div>
              </Card>
            </Col>

            <Col sm="12">
              <Card>
                <div className="profile-img-style">
                  <Row>
                    <Col sm="12">
                      <div className="media-body align-self-center">
                        <h5 className="mt-0 user-name">{"Inverter list"}</h5>
                      </div>
                    </Col>
                    {/* modules in the given string */}
                    <div className="table-responsive">
                      <Table borderless>
                        <thead>
                          <tr>
                            <th scope="col">{"#"}</th>
                            <th scope="col">{"Inverter ID"}</th>
                            <th scope="col">{"Inverter Serial Number"}</th>
                            <th scope="col">{"Inverter Model Number"}</th>
                            <th scope="col">{"Actions"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {inverterList?.map((inverter, index) => {
                            return (
                              <tr>
                                <th scope="row">{index + 1}</th>
                                <td>
                                  <Link to={`/inverter/${inverter?._id}`}>
                                    {inverter?._id}
                                  </Link>
                                </td>
                                <td>{inverter?.serial_number}</td>
                                <td>{inverter?.model_number}</td>
                                <td>
                                  <div>
                                    <Edit />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </Row>
                  <hr />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default BlockDetails;
